//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PageFooter',
  data: () => ({
    columns: [{
      label: 'company',
      items: [
        { label: 'Mission', target: '/mission' },
        { label: 'Sustainability', target: '/sustainability' },
        { label: 'Team SunGod', target: '/pro-team' },
        { label: 'Careers', target: '/careers', tag: 'We\'re hiring!' }
      ]
    }, {
      label: 'support',
      items: [
        { label: 'Shipping & Delivery', target: '/support#/40/what-delivery-method-do-you-use-for-shipping-orders' },
        { label: 'Lifetime Guarantee', target: '/support#/31/what-is-the-sungod-lifetime-guarantee' },
        { label: 'FAQs', target: '/support' },
        { label: 'Contact Us', target: '/support' }
      ]
    }],
    socialLinks: [
      { icon: 'fa fa-facebook', target: 'https://www.facebook.com/sungodsunglasses' },
      { icon: 'fa fa-instagram', target: 'https://www.instagram.com/we_are_sungod' },
      { icon: 'sgi sgi-youtube', target: 'https://www.youtube.com/sungod' },
      { icon: 'sgi sgi-strava', target: 'https://www.strava.com/clubs/sungod' }
    ],
    hovering: null
  }),
  watch: {
    '$route.path': {
      handler () {
        this.hovering = null
      }
    }
  }
}
